<template>
  <div class="page-wrapper">
    <div class="page-container">
      <div class="page-header">
        <div class="breadcrumb">
          <span class="crumb-link" @click="$router.push('/')">Asosiy</span>
          <span class="separator">/</span>
          <span class="crumb-current">Shaxsiy ish reja</span>
        </div>
      </div>

      <!-- Kafedralar Top-N Monitoring (Super Admin) -->
      <KafedralarTopNChart 
        v-if="isAdmin" 
        :userRole="userRole" 
        oquvYili="2026-2027" 
      />

      <!-- Summary Cards -->
      <div class="summary-cards mt-4">
        <!-- O'qituvchi tasdiqlagan -->
        <div 
          class="summary-card card-blue" 
          :class="{ 'card-active': activeStatusFilter === 'teacher_approved' }"
          @click="toggleStatusFilter('teacher_approved')"
          title="O'qituvchi tasdiqlaganlarni filtrlash"
        >
          <div class="card-content">
            <h2 class="card-value">{{ teacherApprovedCount }}</h2>
            <p class="card-label">O'qituvchi tasdiqlagan</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <polyline points="16 11 18 13 22 9"></polyline>
            </svg>
          </div>
        </div>

        <!-- Kafedra mudiri tasdiqlagan -->
        <div 
          class="summary-card card-purple" 
          :class="{ 'card-active': activeStatusFilter === 'kafedra_approved' }"
          @click="toggleStatusFilter('kafedra_approved')"
          title="Kafedra mudiri tasdiqlaganlarni filtrlash"
        >
          <div class="card-content">
            <h2 class="card-value">{{ kafedraApprovedCount }}</h2>
            <p class="card-label">Kafedra mudiri tasdiqlagan</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 21h18"></path>
              <path d="M5 21V7l8-4v18"></path>
              <path d="M19 21V11l-6-4"></path>
              <path d="M9 9h1"></path>
              <path d="M9 13h1"></path>
              <path d="M9 17h1"></path>
            </svg>
          </div>
        </div>

        <!-- Dekan tasdiqlagan -->
        <div 
          class="summary-card card-teal" 
          :class="{ 'card-active': activeStatusFilter === 'dekan_approved' }"
          @click="toggleStatusFilter('dekan_approved')"
          title="Dekan tasdiqlaganlarni filtrlash"
        >
          <div class="card-content">
            <h2 class="card-value">{{ dekanApprovedCount }}</h2>
            <p class="card-label">Dekan tasdiqlagan</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="8" r="6"></circle>
              <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
            </svg>
          </div>
        </div>

        <!-- Prorektor tasdiqlagan -->
        <div 
          class="summary-card card-green" 
          :class="{ 'card-active': activeStatusFilter === 'prorektor_approved' || (!isTeacherRole && currentViewTab === 'approved') }"
          @click="toggleStatusFilter('prorektor_approved')"
          title="Prorektor tasdiqlaganlarni filtrlash"
        >
          <div class="card-content">
            <h2 class="card-value">{{ prorektorApprovedCount }}</h2>
            <p class="card-label">{{ isProrektorRole ? "Tasdiqlanganlar" : "Prorektor tasdiqlagan" }}</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <polyline points="9 12 11 14 15 10"></polyline>
            </svg>
          </div>
        </div>

        <!-- Kutilmoqda -->
        <div 
          class="summary-card card-yellow" 
          :class="{ 'card-active': activeStatusFilter === 'waiting' || (!isTeacherRole && currentViewTab === 'waiting') }"
          @click="toggleStatusFilter('waiting')"
          title="Tasdiq kutilayotganlarni filtrlash"
        >
          <div class="card-content">
            <h2 class="card-value">{{ kutilmoqdaCount }}</h2>
            <p class="card-label">{{ isProrektorRole ? "Tasdiq kutilmoqda" : "Kutilmoqda" }}</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </div>
        </div>

        <!-- Rad etilgan -->
        <div 
          class="summary-card card-red" 
          :class="{ 'card-active': activeStatusFilter === 'rejected' }"
          @click="toggleStatusFilter('rejected')"
          title="Rad etilganlarni filtrlash"
        >
          <div class="card-content">
            <h2 class="card-value">{{ radEtilganCount }}</h2>
            <p class="card-label">Rad etilgan</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          </div>
        </div>
      </div>

      <!-- Active Filter Banner (if a card is clicked) -->
      <div v-if="activeStatusFilter" class="active-filter-banner mt-3 flex items-center justify-between">
        <div class="flex items-center gap-2">
          <span class="text-sm font-semibold text-slate-700">Faol filtr:</span>
          <span class="filter-pill">{{ getActiveFilterName() }} ({{ filteredData.length }} ta)</span>
        </div>
        <button class="btn-clear-filter" @click="clearActiveFilter">
          Filtrni tozalash ✕
        </button>
      </div>

      <!-- Prorektor / Tasdiqlash holati tezkori (Tabs) -->
      <div class="prorektor-tabs-bar mt-4" v-if="isProrektorRole || isDekanRole || isAdmin">
        <div class="prorektor-tabs-wrapper">
          <!-- 1. Tasdiqlash kutilmoqda -->
          <button 
            type="button"
            class="p-tab-btn tab-btn-waiting"
            :class="{ active: currentViewTab === 'waiting' }"
            @click="switchViewTab('waiting')"
          >
            <span class="p-tab-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
            </span>
            <span class="p-tab-title">Tasdiqlash kutilmoqda</span>
            <span class="p-tab-counter counter-amber">{{ myWaitingCount }}</span>
          </button>

          <!-- 2. Prorektor tasdiqlagan -->
          <button 
            type="button"
            class="p-tab-btn tab-btn-approved"
            :class="{ active: currentViewTab === 'approved' }"
            @click="switchViewTab('approved')"
          >
            <span class="p-tab-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
            </span>
            <span class="p-tab-title">{{ isProrektorRole ? "Prorektor tasdiqlagan" : "Tasdiqlanganlar" }}</span>
            <span class="p-tab-counter counter-green">{{ myApprovedCount }}</span>
          </button>

          <!-- 3. Rad etilgan -->
          <button 
            v-if="myRejectedCount > 0"
            type="button"
            class="p-tab-btn tab-btn-rejected"
            :class="{ active: currentViewTab === 'rejected' }"
            @click="switchViewTab('rejected')"
          >
            <span class="p-tab-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
            </span>
            <span class="p-tab-title">Rad etilgan</span>
            <span class="p-tab-counter counter-red">{{ myRejectedCount }}</span>
          </button>

          <!-- 4. Barchasi -->
          <button 
            type="button"
            class="p-tab-btn tab-btn-all"
            :class="{ active: currentViewTab === 'all' }"
            @click="switchViewTab('all')"
          >
            <span class="p-tab-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
            </span>
            <span class="p-tab-title">Barcha rejalar</span>
            <span class="p-tab-counter counter-slate">{{ baseFilteredData.length }}</span>
          </button>
        </div>
      </div>

      <!-- Filters -->
      <div class="filters-row mt-3" v-if="!isTeacherRole">
        <select v-model="selectedDepartment" class="filter-select" @change="fetchEmployees" :disabled="isKafedraMudirRole">
          <option v-if="!isKafedraMudirRole" value="">Kafedra tanlang</option>
          <option v-for="dep in filteredDepartments" :key="dep.id" :value="dep.id">{{ dep.name }}</option>
        </select>

        <select v-model="selectedStavka" class="filter-select ml-4">
          <option value="">Stavka tanlang</option>
          <option v-for="rate in stavkaList" :key="rate" :value="rate">{{ rate }}</option>
        </select>

        <div class="search-box ml-4">
          <input type="text" v-model="searchQuery" placeholder="F.I.SH bo'yicha qidirish" class="search-input" />
          <button class="search-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          </button>
        </div>

        <button class="btn-clear ml-4" @click="clearFilters">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          Filtrni tozalash
        </button>

        <button class="btn-filter ml-auto" @click="fetchEmployees">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
          Filtrlash
        </button>

        <button 
          class="btn-sync-emp ml-3" 
          :disabled="syncing" 
          @click="syncEmployeesDatabase" 
          title="HEMIS dan faol xodimlarni yangilash (bo'shaganlarni chiqarib tashlash)"
        >
          <span v-if="syncing" class="spinner-small"></span>
          <span v-else>🔄</span>
          {{ syncing ? "Yangilanmoqda..." : "Xodimlarni yangilash" }}
        </button>
      </div>

      <!-- Table -->
      <div class="table-card mt-4">
        <div v-if="loading" class="text-center py-8 text-gray-500">Yuklanmoqda...</div>
        <table v-else class="main-table">
          <thead>
            <tr>
              <th class="w-12 text-center">#</th>
              <th class="text-left">F.I.O</th>
              <th class="text-center">Stavka</th>
              <th class="text-left">Kafedra</th>
              <th class="text-center">Auditoriya soati</th>
              <th class="text-center">Auditoriyadan tashqari</th>
              <th class="text-center">Jami</th>
              <th class="text-center">Holati</th>
              <th class="w-32 text-center">Amal</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="filteredData.length === 0">
              <td colspan="9" class="text-center py-8 text-gray-500">Ma'lumot topilmadi</td>
            </tr>
            <tr v-for="(item, index) in filteredData" :key="item.employeeId ? (item.employeeId + '_' + item.stavka) : index">
              <td class="text-center text-gray-500">{{ index + 1 }}.</td>
              <td class="emp-name clickable-link" @click="goToDetail(item)">{{ item.employeeName }}</td>
              <td class="text-center">{{ item.stavka }}</td>
              <td>{{ item.kafedraName }}</td>
              <td class="text-center">{{ item.auditoriyaSoati }}</td>
              <td class="text-center">{{ item.tashqariSoati }}</td>
              <td class="text-center font-bold">{{ item.jamiSoati }}</td>
              <td class="text-center">
                <span class="status-badge" :class="getStatusClass(item)">{{ getStatusText(item) }}</span>
              </td>
              <td class="text-center">
                <button 
                  v-if="isWaitingForMe(item)" 
                  class="btn-row-action btn-action-approve" 
                  @click="goToDetail(item)"
                  title="Ko'rib chiqish va tasdiqlash"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>
                  Tasdiqlash
                </button>
                <button 
                  v-else 
                  class="btn-row-action btn-action-view" 
                  @click="goToDetail(item)"
                  title="Batafsil ko'rish"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  Ko'rish
                </button>
              </td>
            </tr>
          </tbody>
          <!-- JAMI (FOOTER) QATOR -->
          <tfoot v-if="filteredData.length > 0" class="table-totals-footer">
            <tr class="totals-row">
              <td colspan="4" class="totals-title-cell text-right font-bold pr-4">Jami:</td>
              <td class="totals-val-cell text-center font-bold text-blue-700">{{ totals.auditoriyaSoati }}</td>
              <td class="totals-val-cell text-center font-bold text-indigo-700">{{ totals.tashqariSoati }}</td>
              <td class="totals-val-cell text-center font-bold text-emerald-700 totals-grand-val">{{ totals.jamiSoati }}</td>
              <td colspan="2"></td>
            </tr>
          </tfoot>
        </table>
        
        <!-- Pagination info -->
        <div class="pagination-footer mt-4 text-sm text-gray-500">
          <span v-if="filteredData.length > 0">{{ filteredData.length }} / jami {{ mergedData.length }} ta</span>
          
          <div class="page-numbers float-right" v-if="filteredData.length > 0">
            <span class="page-number active">1</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import KafedralarTopNChart from "@/components/KafedralarTopNChart.vue";

const API = process.env.VUE_APP_API_URL;

// Kafedralarning tegishli fakultetiga (parent ID) mosligi
const KAFEDRA_TO_FACULTY = {
  11: 1, 12: 1, 13: 1, 15: 1, // Energetika va sanoat muhandisligi (1)
  6: 2, 7: 2, 9: 2, 10: 2,     // Mexanika va konchilik ishi (2)
  14: 3, 19: 3, 66: 3,         // Muhandislik (3)
  20: 4, 21: 4, 23: 4, 24: 4,  // Agrobiologiya (4)
  25: 5, 26: 5, 67: 5,         // Iqtisodiyot (5)
  16: 65, 18: 65               // Qurilish materiallari sanoati (65)
};

export default {
  name: "ShaxsiyIshReja",
  components: {
    KafedralarTopNChart
  },
  data() {
    return {
      selectedDepartment: "",
      selectedStavka: "",
      searchQuery: "",
      activeStatusFilter: "",
      currentViewTab: sessionStorage.getItem("shaxsiy_reja_current_tab") || "waiting",
      departments: [],
      employees: [],
      assignments: [],
      assignmentMap: {},  // employeeId -> plan
      loading: false,
      userRole: "",
      userDepartmentId: null,
      loggedInUser: null,
      syncing: false,
    };
  },
  computed: {
    totals() {
      let auditoriyaSoati = 0;
      let tashqariSoati = 0;
      let jamiSoati = 0;
      for (const item of this.filteredData) {
        auditoriyaSoati += (item.auditoriyaSoati || 0);
        tashqariSoati += (item.tashqariSoati || 0);
        jamiSoati += (item.jamiSoati || 0);
      }
      return {
        auditoriyaSoati: Number(auditoriyaSoati.toFixed(1)),
        tashqariSoati: Number(tashqariSoati.toFixed(1)),
        jamiSoati: Number(jamiSoati.toFixed(1))
      };
    },
    mergedData() {
      let result = [];
      const seenAppointments = new Set();

      const checkNamesMatch = (nameA, nameB) => {
        if (!nameA || !nameB) return false;
        const a = nameA.trim().toLowerCase().replace(/['‘`´"ʻ]/g, "'");
        const b = nameB.trim().toLowerCase().replace(/['‘`´"ʻ]/g, "'");
        if (a === b) return true;
        const aParts = a.split(/\s+/).filter(Boolean);
        const bParts = b.split(/\s+/).filter(Boolean);
        if (aParts.length >= 2 && bParts.length >= 2) {
          return (aParts[0] === bParts[0] && aParts[1] === bParts[1]) ||
                 (aParts[0] === bParts[1] && aParts[1] === bParts[0]);
        }
        return false;
      };

      // Faqat amalda ishlayotgan (Ishlamoqda) xodimlar
      let activeEmployees = (this.employees || []).filter(emp => {
        if (!emp) return false;
        const statusCode = String(emp.employeeStatus?.code || '').trim();
        const statusName = (emp.employeeStatus?.name || '').toLowerCase().trim();
        if (statusCode === '14' || statusName.includes('bo‘sha') || statusName.includes('bo\'sha') || statusName.includes('boshagan') || statusName.includes('dismissed')) {
          return false;
        }
        return true;
      });

      // Agar o'qituvchi bo'lsa, xodimlar ro'yxatini ham FAQAT o'ziga cheklaymiz
      if (this.isTeacherRole && this.loggedInUser) {
        const myName = (this.loggedInUser.name || this.loggedInUser.fullName || '').toLowerCase().trim();
        const myEmpId = String(this.loggedInUser.employee_id_number || '').trim();
        activeEmployees = activeEmployees.filter(emp => {
          const empIdNum = String(emp.employee_id_number || '');
          if (myEmpId && myEmpId.length >= 7 && empIdNum === myEmpId) return true;
          const eName = (emp.full_name || emp.name || '').toLowerCase().trim();
          return checkNamesMatch(myName, eName);
        });
      }

      // 1. Shaxsiy reja hujjatlarini qo'shish (this.assignments)
      for (const plan of this.assignments) {
        const empId = String(plan.employeeId);

        // Amalda ishlayotgan xodimlar ichidan qidirish:
        let planStavka = (plan.stavka || plan.teacherMeta?.stavka || "1,00 stavka").trim();
        if (!planStavka.toLowerCase().includes("stavka")) {
          planStavka = `${planStavka} stavka`;
        }

        const pName = (plan.employeeName || '').trim().toLowerCase();

        let emp = activeEmployees.find(e => {
          const eIdNumber = String(e.employee_id_number || e.id || '');
          const eMetaId = String(e.meta_id || '');
          const eName = (e.full_name || e.name || '').trim().toLowerCase();
          const matchesPerson = eIdNumber === empId || eMetaId === empId || checkNamesMatch(pName, eName);
          const eStavka = (e.employmentStaff?.name || '').toLowerCase().trim();
          return matchesPerson && eStavka.includes(planStavka.toLowerCase().replace(" stavka", "").trim());
        });

        // Agar aynan stavkasi bilan topilmasa, shaxs bo'yicha topamiz
        if (!emp) {
          emp = activeEmployees.find(e => {
            const eIdNumber = String(e.employee_id_number || e.id || '');
            const eMetaId = String(e.meta_id || '');
            const eName = (e.full_name || e.name || '').trim().toLowerCase();
            return eIdNumber === empId || eMetaId === empId || checkNamesMatch(pName, eName);
          }) || {};
        }

        const isKnownActive = activeEmployees.length === 0 || !!emp.full_name || !!emp.name;
        if (activeEmployees.length > 0 && !isKnownActive) {
          continue;
        }

        // Stavkani belgilash:
        let stavka = plan.stavka || plan.teacherMeta?.stavka;
        const isSecondaryId = empId.length < 7;
        const isSecondaryForm = String(emp.employmentForm?.code || '') !== '11' && !!emp.employmentForm?.code;

        // Xodimning faol lavozimlari soni
        const pNormalizedName = (plan.employeeName || '').trim().toLowerCase();
        const empAppointments = activeEmployees.filter(e => {
          const eIdNumber = String(e.employee_id_number || e.id || '');
          const eName = (e.full_name || e.name || '').trim().toLowerCase();
          return (empId && (eIdNumber === empId || String(e.meta_id || '') === empId)) || (pNormalizedName && checkNamesMatch(pNormalizedName, eName));
        });
        const hasSinglePosition = empAppointments.length <= 1;
        const empStaffName = emp.employmentStaff?.name || "";
        const isFractionStaff = empStaffName.includes("0,") || empStaffName.includes("0.");

        if (stavka && !stavka.includes("1,00") && !stavka.includes("1.00")) {
          // Keep existing non-full stavka (e.g. 0,25 stavka or 0,50 stavka)
        } else if (isFractionStaff) {
          stavka = empStaffName;
        } else if (isSecondaryId || isSecondaryForm) {
          stavka = "0,50 stavka";
        } else if (hasSinglePosition && empStaffName) {
          stavka = empStaffName;
        } else if (!isSecondaryId && !hasSinglePosition) {
          stavka = "1,00 stavka";
        } else if (!stavka) {
          stavka = empStaffName || "1,00 stavka";
        }
        if ((isSecondaryId || isSecondaryForm) && (stavka.includes("1,00") || stavka.includes("1.00"))) {
          stavka = isFractionStaff ? empStaffName : "0,50 stavka";
        }
        if (stavka && !stavka.toLowerCase().includes("stavka")) {
          stavka = `${stavka} stavka`;
        }

        const normStavka = stavka.toLowerCase().trim();
        seenAppointments.add(`${empId}_${normStavka}`);
        if (emp.employee_id_number) seenAppointments.add(`${emp.employee_id_number}_${normStavka}`);
        if (emp.id) seenAppointments.add(`${emp.id}_${normStavka}`);
        if (emp.meta_id) seenAppointments.add(`${emp.meta_id}_${normStavka}`);
        const normalizedEmpName = (emp.full_name || plan.employeeName || '').trim().toLowerCase();
        if (normalizedEmpName) seenAppointments.add(`${normalizedEmpName}_${normStavka}`);

        const employeeName = (plan.employeeName && !plan.employeeName.startsWith("O'qituvchi ("))
          ? plan.employeeName
          : (emp.full_name || plan.employeeName || "");
        const degree = (plan.degree && plan.degree !== "Darajasiz")
          ? plan.degree
          : (emp.academicDegree?.name || plan.degree || "Darajasiz");
        const rank = (plan.rank && plan.rank !== "Unvonsiz")
          ? plan.rank
          : (emp.academicRank?.name || plan.rank || "Unvonsiz");
        const position = (plan.position && plan.position !== "O'qituvchi")
          ? plan.position
          : (emp.staffPosition?.name || plan.position || "O'qituvchi");

        result.push({
          employeeId: empId,
          employeeName,
          stavka,
          kafedraName: (emp.department && emp.department.name) ? emp.department.name : (plan.kafedraName || ""),
          departmentId: (emp.department && emp.department.id) ? emp.department.id : (plan.departmentId || null),
          auditoriyaSoati: Number((plan.auditoriyaSoati || 0).toFixed(1)),
          tashqariSoati: Number((plan.tashqariSoati || 0).toFixed(1)),
          jamiSoati: Number((plan.jamiSoati || (plan.auditoriyaSoati || 0) + (plan.tashqariSoati || 0)).toFixed(1)),
          status: plan.status || null,
          degree,
          rank,
          position,
          teacherMeta: plan.teacherMeta || null,
          meta_id: emp.meta_id || (empId.length < 10 ? empId : null),
          employee_id_number: emp.employee_id_number || (empId.length >= 10 ? empId : null),
          employeePhone: emp.phone || emp.employeePhone || ""
        });
      }

      // 2. Rejasi hali shakllanmagan yoki o'rindoshlik lavozimlari (HEMIS dan)
      for (const emp of activeEmployees) {
        const empIdNumber = emp.employee_id_number ? String(emp.employee_id_number) : '';
        const empIdStr = emp.id ? String(emp.id) : '';
        const empMetaId = emp.meta_id ? String(emp.meta_id) : '';
        const empEmployeeId = emp.employee_id ? String(emp.employee_id) : '';
        const empName = (emp.full_name || emp.short_name || `${emp.second_name || ''} ${emp.first_name || ''} ${emp.third_name || ''}`).trim().toLowerCase();

        let stavka = "1,00 stavka";
        if (emp.employmentStaff && emp.employmentStaff.name) {
          const match = emp.employmentStaff.name.match(/([\d.,]+)\s*stavka/i);
          if (match) stavka = match[1] + " stavka";
          else stavka = emp.employmentStaff.name;
        }
        if (stavka && !stavka.toLowerCase().includes("stavka")) {
          stavka = `${stavka} stavka`;
        }
        // Check if another plan already exists for this person (e.g. primary 1.00 stavka plan)
        const hasExistingPrimaryPlan = (this.assignments || []).some(p => {
          const pEmpId = String(p.employeeId);
          const pName = (p.employeeName || '').trim().toLowerCase();
          return pEmpId === empIdNumber || checkNamesMatch(pName, empName);
        });

        // Agar xodimning bu kafedrada faqat bitta faol lavozimi bo'lsa va uning rejasi allaqachon mavjud bo'lsa, qayta qo'shilmasin
        const personActiveApps = activeEmployees.filter(e => {
          const eIdNumber = String(e.employee_id_number || e.id || '');
          const eName = (e.full_name || e.name || '').trim().toLowerCase();
          return (empIdNumber && eIdNumber === empIdNumber) || checkNamesMatch(empName, eName);
        });
        if (hasExistingPrimaryPlan && personActiveApps.length <= 1) {
          continue;
        }

        const isSecondary = String(emp.employmentForm?.code || '') !== '11';
        const empStaffName = emp.employmentStaff?.name || "";
        const isFractionStaff = empStaffName.includes("0,") || empStaffName.includes("0.");
        stavka = "1,00 stavka";
        if (isSecondary) {
          stavka = isFractionStaff ? empStaffName : "0,50 stavka";
        } else {
          stavka = empStaffName || "1,00 stavka";
        }
        if (stavka && !stavka.toLowerCase().includes("stavka")) {
          stavka = `${stavka} stavka`;
        }
        const normStavka = stavka.toLowerCase().trim();

        const distinctEmpId = (hasExistingPrimaryPlan && empMetaId) 
          ? empMetaId 
          : (emp.distinct_id || empIdNumber || empIdStr || empEmployeeId || empMetaId);

        // Agar bu lavozim/stavka allaqachon mavjud bo'lsa, qayta qo'shilmasin
        if (
          seenAppointments.has(`${distinctEmpId}_${normStavka}`) ||
          (empMetaId && seenAppointments.has(`${empMetaId}_${normStavka}`)) ||
          (empIdNumber && seenAppointments.has(`${empIdNumber}_${normStavka}`)) ||
          (empIdStr && seenAppointments.has(`${empIdStr}_${normStavka}`)) ||
          (empName && seenAppointments.has(`${empName}_${normStavka}`))
        ) {
          continue;
        }

        seenAppointments.add(`${distinctEmpId}_${normStavka}`);
        if (empMetaId) seenAppointments.add(`${empMetaId}_${normStavka}`);
        if (empIdNumber) seenAppointments.add(`${empIdNumber}_${normStavka}`);
        if (empName) seenAppointments.add(`${empName}_${normStavka}`);

        let kafedraName = emp.department?.name || "";
        let employeeName = emp.full_name || emp.short_name || `${emp.second_name || ""} ${emp.first_name || ""} ${emp.third_name || ""}`.trim();

        result.push({
          employeeId: distinctEmpId,
          employeeName,
          stavka,
          kafedraName,
          departmentId: emp.department ? emp.department.id : null,
          auditoriyaSoati: 0,
          tashqariSoati: 0,
          jamiSoati: 0,
          status: null,
          degree: emp.academicDegree?.name || "Darajasiz",
          rank: emp.academicRank?.name || "Unvonsiz",
          position: emp.staffPosition?.name || "O'qituvchi",
          teacherMeta: null,
          meta_id: emp.meta_id || (distinctEmpId.length < 10 ? distinctEmpId : null),
          employee_id_number: emp.employee_id_number || (distinctEmpId.length >= 10 ? distinctEmpId : null),
          employeePhone: emp.phone || emp.employeePhone || ""
        });
      }

      if (this.selectedDepartment && !this.isTeacherRole) {
        result = result.filter(d => String(d.departmentId) === String(this.selectedDepartment));
      }

      // Dekan roli uchun: agar alohida kafedra tanlanmagan bo'lsa, faqat o'z fakultetiga qarashli kafedralar xodimlarini ko'rsatish
      if (this.isDekanRole) {
        const fId = Number(this.userDepartmentId);
        if (fId && fId !== 31) {
          const allowedDeptIds = new Set(this.filteredDepartments.map(d => String(d.id)));
          result = result.filter(d => allowedDeptIds.has(String(d.departmentId)));
        }
      }

      // Prorektorlar uchun bosqichma-bosqich ko'rsatish:
      // 1. Yoshlar ishlari prorektori: Dekan tasdiqlaganlarini ko'radi
      if (this.isYoshlarProrektor) {
        result = result.filter(d => d.status && d.status.dekan === "approved");
      }
      // 2. Ilmiy ishlari prorektori: Yoshlar ishlari bo'yicha prorektor tasdiqlaganlarini ko'radi
      else if (this.isIlmiyProrektor) {
        result = result.filter(d => d.status && d.status.yoshlar === "approved");
      }
      // 3. O'quv ishlari prorektori: Ilmiy ishlari bo'yicha prorektor tasdiqlaganlarini ko'radi
      else if (this.isOquvProrektor) {
        result = result.filter(d => d.status && d.status.ilmiy === "approved");
      }
      // Tartiblash: F.I.Sh bo'yicha alifbo tartibida, bir xil xodim uchun stavkasi bo'yicha (1.00 stavka birinchi, 0.50 stavka keyin)
      result.sort((a, b) => {
        const nameA = (a.employeeName || '').trim().toLowerCase();
        const nameB = (b.employeeName || '').trim().toLowerCase();
        if (nameA !== nameB) {
          return nameA.localeCompare(nameB, 'uz');
        }
        const parseStavka = (s) => {
          if (!s) return 0;
          const m = String(s).replace(',', '.').match(/[\d.]+/);
          return m ? parseFloat(m[0]) : 0;
        };
        return parseStavka(b.stavka) - parseStavka(a.stavka);
      });

      return result;
    },
    stavkaList() {
      const rates = this.mergedData.map(d => d.stavka).filter(Boolean);
      const uniqueRates = [...new Set(rates)];
      return uniqueRates.sort((a, b) => {
        const numA = parseFloat(a) || 0;
        const numB = parseFloat(b) || 0;
        return numB - numA;
      });
    },
    baseFilteredData() {
      let data = this.mergedData;
      
      if (this.isTeacherRole) {
        const loggedInEmployeeId = this.loggedInUser?.employee_id_number || 
                                   (String(this.loggedInUser?.employee_id || '').length >= 7 ? this.loggedInUser?.employee_id : null) || 
                                   this.loggedInUser?.hemis_id;
        const loggedInMetaId = this.loggedInUser?.meta_id || null;
        const loggedInName = (this.loggedInUser?.name || this.loggedInUser?.fullName || "").toLowerCase().trim();
        const loggedInPhone = (this.loggedInUser?.phone || "").toLowerCase().trim();

        const cleanA = loggedInName.replace(/['‘`´"ʻ]/g, "'").replace(/\s+/g, ' ').trim();
        const p1 = cleanA.split(' ').filter(Boolean);

        // 1. Foydalanuvchiga tegishli barcha ID larni (meta_id, employee_id_number) activeEmployees dan yig'amiz
        const myAllowedIds = new Set();
        if (loggedInEmployeeId) myAllowedIds.add(String(loggedInEmployeeId));
        if (loggedInMetaId) myAllowedIds.add(String(loggedInMetaId));

        (this.employees || []).forEach(emp => {
          const empIdNum = emp.employee_id_number ? String(emp.employee_id_number) : '';
          const empMeta = emp.meta_id ? String(emp.meta_id) : '';
          const empId = emp.id ? String(emp.id) : '';
          const empFullName = (emp.full_name || emp.name || '').toLowerCase().trim();

          const isIdMatch = (loggedInEmployeeId && (empIdNum === String(loggedInEmployeeId) || empId === String(loggedInEmployeeId))) ||
                            (loggedInMetaId && empMeta === String(loggedInMetaId));
          
          let isNameMatch = false;
          if (cleanA && empFullName) {
            const cleanB = empFullName.replace(/['‘`´"ʻ]/g, "'").replace(/\s+/g, ' ').trim();
            if (cleanA === cleanB || cleanB.includes(cleanA) || cleanA.includes(cleanB)) {
              isNameMatch = true;
            } else {
              const p2 = cleanB.split(' ').filter(Boolean);
              if (p1.length >= 2 && p2.length >= 2) {
                const matchOrder1 = p1[0] === p2[0] && p1[1] === p2[1];
                const matchOrder2 = p1[0] === p2[1] && p1[1] === p2[0];
                const bothInParts = p1.every(part => p2.includes(part));
                if (matchOrder1 || matchOrder2 || bothInParts) {
                  isNameMatch = true;
                }
              }
            }
          }

          if (isIdMatch || isNameMatch) {
            if (empIdNum) myAllowedIds.add(empIdNum);
            if (empMeta) myAllowedIds.add(empMeta);
          }
        });

        // O'qituvchining barcha lavozimlarini (asosiy 1.00 stavka va o'rindoshlik 0.50 stavkalarini) ko'rsatish
        data = data.filter(d => {
          // 1. Agar ID aynan mos kelsa (asosiy 10 xonali ID yoki meta_id yoki to'plangan myAllowedIds)
          const dEmpId = d.employeeId ? String(d.employeeId) : '';
          const dMetaId = d.meta_id ? String(d.meta_id) : '';
          const dEmpIdNum = d.employee_id_number ? String(d.employee_id_number) : '';

          if (dEmpId && myAllowedIds.has(dEmpId)) return true;
          if (dMetaId && myAllowedIds.has(dMetaId)) return true;
          if (dEmpIdNum && myAllowedIds.has(dEmpIdNum)) return true;

          // 2. F.I.Sh bo'yicha qat'iy tekshirish (Familiya va Ism birdek mos kelishi)
          if (cleanA && d.employeeName) {
            const cleanD = d.employeeName.toLowerCase().replace(/['‘`´"ʻ]/g, "'").replace(/\s+/g, ' ').trim();
            if (cleanA === cleanD || cleanD.includes(cleanA) || cleanA.includes(cleanD)) return true;
            const pD = cleanD.split(' ').filter(Boolean);
            if (p1.length >= 2 && pD.length >= 2) {
              const matchOrder1 = p1[0] === pD[0] && p1[1] === pD[1];
              const matchOrder2 = p1[0] === pD[1] && p1[1] === pD[0];
              const bothInParts = p1.every(part => pD.includes(part));
              if (matchOrder1 || matchOrder2 || bothInParts) return true;
            }
          }

          // 3. Telefon raqami bo'yicha (faqat haqiqiy telefon bo'lsa)
          if (loggedInPhone && loggedInPhone.length >= 9 && (d.employeePhone || "").toLowerCase().trim() === loggedInPhone) {
            return true;
          }

          return false;
        });

        if (this.selectedStavka) data = data.filter(d => d.stavka === this.selectedStavka);
        if (this.searchQuery) {
          const query = this.searchQuery.toLowerCase();
          data = data.filter(d => (d.employeeName || "").toLowerCase().includes(query));
        }
        return data;
      }
      
      if (this.selectedStavka) {
        data = data.filter(d => d.stavka === this.selectedStavka);
      }

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        data = data.filter(d => (d.employeeName || "").toLowerCase().includes(query));
      }
      
      return data;
    },
    isWaitingForMe() {
      return (item) => {
        if (!item || !item.status) return false;
        const st = item.status;
        const isRejected = Object.values(st).some(v => v === 'rejected');
        if (isRejected) return false;

        if (this.isYoshlarProrektor) {
          return st.dekan === 'approved' && st.yoshlar !== 'approved';
        }
        if (this.isIlmiyProrektor) {
          return st.yoshlar === 'approved' && st.ilmiy !== 'approved';
        }
        if (this.isOquvProrektor) {
          return st.ilmiy === 'approved' && st.oquv !== 'approved';
        }
        if (this.isProrektorRole) {
          const isApproved = st.oquv === 'approved' || st.ilmiy === 'approved' || st.yoshlar === 'approved';
          return st.dekan === 'approved' && !isApproved;
        }
        if (this.isDekanRole) {
          return st.kafedra === 'approved' && st.dekan !== 'approved';
        }
        if (this.isKafedraMudirRole) {
          return st.teacher === 'approved' && st.kafedra !== 'approved';
        }
        return false;
      };
    },
    isApprovedByMe() {
      return (item) => {
        if (!item || !item.status) return false;
        const st = item.status;
        if (this.isYoshlarProrektor) {
          return st.yoshlar === 'approved';
        }
        if (this.isIlmiyProrektor) {
          return st.ilmiy === 'approved';
        }
        if (this.isOquvProrektor) {
          return st.oquv === 'approved';
        }
        if (this.isProrektorRole) {
          return st.oquv === 'approved' || st.ilmiy === 'approved' || st.yoshlar === 'approved';
        }
        if (this.isDekanRole) {
          return st.dekan === 'approved';
        }
        if (this.isKafedraMudirRole) {
          return st.kafedra === 'approved';
        }
        return false;
      };
    },
    myWaitingCount() {
      return this.baseFilteredData.filter(d => this.isWaitingForMe(d)).length;
    },
    myApprovedCount() {
      return this.baseFilteredData.filter(d => this.isApprovedByMe(d)).length;
    },
    myRejectedCount() {
      return this.baseFilteredData.filter(d => d.status && Object.values(d.status).some(v => v === 'rejected')).length;
    },
    filteredData() {
      let data = this.baseFilteredData;

      // 1. Prorektor/Dekan/Kafedra mudiri tab filtri (o'qituvchiga nisbatan qo'llanmaydi)
      if (!this.isTeacherRole) {
        if (this.currentViewTab === 'waiting') {
          data = data.filter(d => this.isWaitingForMe(d));
        } else if (this.currentViewTab === 'approved') {
          data = data.filter(d => this.isApprovedByMe(d));
        } else if (this.currentViewTab === 'rejected') {
          data = data.filter(d => d.status && Object.values(d.status).some(v => v === 'rejected'));
        }
      }

      // 2. Summary kartochka bosilganda qo'shimcha filtr
      if (this.activeStatusFilter) {
        if (this.activeStatusFilter === 'teacher_approved') {
          data = data.filter(d => d.status && d.status.teacher === 'approved');
        } else if (this.activeStatusFilter === 'kafedra_approved') {
          data = data.filter(d => d.status && d.status.kafedra === 'approved');
        } else if (this.activeStatusFilter === 'dekan_approved') {
          data = data.filter(d => d.status && d.status.dekan === 'approved');
        } else if (this.activeStatusFilter === 'prorektor_approved') {
          if (this.isTeacherRole) {
            data = data.filter(d => d.status && (d.status.oquv === 'approved' || d.status.ilmiy === 'approved' || d.status.yoshlar === 'approved'));
          } else {
            data = data.filter(d => this.isApprovedByMe(d));
          }
        } else if (this.activeStatusFilter === 'waiting') {
          if (this.isTeacherRole) {
            data = data.filter(d => {
              if (!d.status) return true;
              const isRejected = Object.values(d.status).some(val => val === 'rejected');
              if (isRejected) return false;
              const isProrektor = d.status.oquv === 'approved' || d.status.ilmiy === 'approved' || d.status.yoshlar === 'approved';
              return !isProrektor;
            });
          } else {
            data = data.filter(d => this.isWaitingForMe(d));
          }
        } else if (this.activeStatusFilter === 'rejected') {
          data = data.filter(d => d.status && Object.values(d.status).some(val => val === 'rejected'));
        }
      }

      return data;
    },
    teacherApprovedCount() {
      return this.baseFilteredData.filter(d => d.status && d.status.teacher === "approved").length;
    },
    kafedraApprovedCount() {
      return this.baseFilteredData.filter(d => d.status && d.status.kafedra === "approved").length;
    },
    dekanApprovedCount() {
      return this.baseFilteredData.filter(d => d.status && d.status.dekan === "approved").length;
    },
    prorektorApprovedCount() {
      if (this.isProrektorRole) {
        return this.myApprovedCount;
      }
      return this.baseFilteredData.filter(d => d.status && (d.status.oquv === "approved" || d.status.ilmiy === "approved" || d.status.yoshlar === "approved")).length;
    },
    radEtilganCount() {
      return this.myRejectedCount;
    },
    kutilmoqdaCount() {
      if (this.isProrektorRole || this.isDekanRole) {
        return this.myWaitingCount;
      }
      return this.baseFilteredData.filter(d => {
        if (!d.status) return true;
        const isRejected = Object.values(d.status).some(val => val === "rejected");
        if (isRejected) return false;
        const isProrektor = d.status.oquv === "approved" || d.status.ilmiy === "approved" || d.status.yoshlar === "approved";
        return !isProrektor;
      }).length;
    },
    tasdiqlanganCount() {
      return this.prorektorApprovedCount;
    },
    isDekanRole() {
      const roleLower = (this.userRole || "").toLowerCase().trim();
      return ["dekan", "dean", "fakultet dekani"].some(r => roleLower.includes(r));
    },
    isYoshlarProrektor() {
      const roleLower = (this.userRole || "").toLowerCase().trim().replace(/[`‘']/g, "'");
      return roleLower.includes("prorektor") && roleLower.includes("yoshlar");
    },
    isIlmiyProrektor() {
      const roleLower = (this.userRole || "").toLowerCase().trim().replace(/[`‘']/g, "'");
      return roleLower.includes("prorektor") && roleLower.includes("ilmiy");
    },
    isOquvProrektor() {
      const roleLower = (this.userRole || "").toLowerCase().trim().replace(/[`‘']/g, "'");
      return roleLower.includes("prorektor") && (roleLower.includes("o'quv") || roleLower.includes("oquv"));
    },
    isProrektorRole() {
      const roleLower = (this.userRole || "").toLowerCase().trim();
      return roleLower.includes("prorektor");
    },
    filteredDepartments() {
      if (this.isKafedraMudirRole) {
        return this.departments.filter(dep => String(dep.id) === String(this.userDepartmentId));
      }
      if (this.isDekanRole) {
        const fId = Number(this.userDepartmentId);
        if (fId === 31) {
          // Magistratura bo'limi dekani barcha kafedralarni ko'radi
          return this.departments;
        }
        if (fId) {
          return this.departments.filter(dep => {
            const parentId = Number(dep.parent?.id || dep.parent || KAFEDRA_TO_FACULTY[dep.id]);
            return parentId === fId;
          });
        }
      }
      return this.departments;
    },
    isKafedraMudirRole() {
      const roleLower = (this.userRole || "").toLowerCase().trim();
      return ["kafedra mudiri", "kafedra_mudiri"].includes(roleLower) && !!this.userDepartmentId;
    },
    isTeacherRole() {
      const roleLower = (this.userRole || "").toLowerCase().trim();
      return [
        "qituvchi", "teacher", "assistent", "assistant",
        "dotsent", "docent", "professor", "stajyor",
        "foydalanuvchi", "user"
      ].some(r => roleLower.includes(r));
    },
    isAdmin() {
      const r = (this.userRole || "").trim().toLowerCase();
      return ["super admin", "superadmin", "admin", "administrator"].includes(r);
    }
  },
  watch: {
    selectedDepartment(newVal) {
      if (newVal) {
        sessionStorage.setItem("shaxsiy_reja_selected_department", String(newVal));
      } else {
        sessionStorage.removeItem("shaxsiy_reja_selected_department");
      }
    },
    '$route.query.departmentId'(newVal) {
      if (newVal && !this.isKafedraMudirRole) {
        const formatted = !isNaN(Number(newVal)) && Number(newVal) > 0 ? Number(newVal) : newVal;
        if (this.selectedDepartment !== formatted) {
          this.selectedDepartment = formatted;
          this.fetchEmployees();
        }
      }
    },
    currentViewTab(newVal) {
      if (newVal) {
        sessionStorage.setItem("shaxsiy_reja_current_tab", newVal);
      }
    },
    '$route.query.tab'(newVal) {
      if (newVal && this.currentViewTab !== newVal) {
        this.currentViewTab = newVal;
      }
    }
  },
  async created() {
    // Read user info from localStorage
    try {
      const data = localStorage.getItem("user");
      if (data && data !== "undefined") {
        const parsed = JSON.parse(data);
        if (
          (parsed.phone === 'j_raxmankulov' || (parsed.name && parsed.name.toLowerCase().includes('raxmankulov'))) &&
          Number(parsed.departmentId) !== 12
        ) {
          parsed.departmentId = 12;
          localStorage.setItem("user", JSON.stringify(parsed));
        }
        this.userRole = parsed.role || "";
        this.userDepartmentId = parsed.departmentId || null;
        this.loggedInUser = parsed;

        // Agar Dekan bo'lsa va departmentId kafedra ID si bo'lib qolgan bo'lsa, uni fakultet ID ga moslaymiz
        if (this.isDekanRole && this.userDepartmentId) {
          const dId = Number(this.userDepartmentId);
          const facultyIds = [1, 2, 3, 4, 5, 31, 65];
          if (!facultyIds.includes(dId) && KAFEDRA_TO_FACULTY[dId]) {
            this.userDepartmentId = KAFEDRA_TO_FACULTY[dId];
          }
        }

        // Kafedra mudiri uchun avtomatik o'z kafedrasini tanlash
        if (this.isKafedraMudirRole && this.userDepartmentId) {
          this.selectedDepartment = this.userDepartmentId;
        } else {
          const queryDept = this.$route.query.departmentId || this.$route.query._department;
          const savedDept = sessionStorage.getItem("shaxsiy_reja_selected_department");
          const deptToRestore = queryDept || savedDept;
          if (deptToRestore) {
            this.selectedDepartment = !isNaN(Number(deptToRestore)) && Number(deptToRestore) > 0 ? Number(deptToRestore) : deptToRestore;
          }
        }
      }
    } catch (e) { /* ignore */ }

    if (!this.selectedDepartment && !this.isKafedraMudirRole) {
      const queryDept = this.$route.query.departmentId || this.$route.query._department;
      const savedDept = sessionStorage.getItem("shaxsiy_reja_selected_department");
      const deptToRestore = queryDept || savedDept;
      if (deptToRestore) {
        this.selectedDepartment = !isNaN(Number(deptToRestore)) && Number(deptToRestore) > 0 ? Number(deptToRestore) : deptToRestore;
      }
    }

    // Tabni saqlangan holatdan tiklash
    if (this.isTeacherRole) {
      this.currentViewTab = "all";
      this.activeStatusFilter = "";
      sessionStorage.setItem("shaxsiy_reja_current_tab", "all");
    } else {
      const queryTab = this.$route.query.tab;
      const savedTab = sessionStorage.getItem("shaxsiy_reja_current_tab");
      if (queryTab) {
        this.currentViewTab = queryTab;
      } else if (savedTab) {
        this.currentViewTab = savedTab;
      } else if (this.isProrektorRole) {
        this.currentViewTab = "waiting";
      }
    }

    this.fetchDepartments();
    this.fetchEmployees();
  },
  methods: {
    async fetchDepartments() {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/departments`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          this.departments = res.data.data;
          if (this.selectedDepartment && this.departments.length > 0) {
            const found = this.departments.find(d => String(d.id) === String(this.selectedDepartment));
            if (found) {
              this.selectedDepartment = found.id;
            }
          }
        }
      } catch (err) {
        console.error("Error fetching departments", err);
      }
    },
    async fetchEmployees() {
      this.loading = true;
      try {
        const token = localStorage.getItem("token");
        const empParams = { limit: 2000, type: 'teacher' };
        if (this.isKafedraMudirRole) {
          this.selectedDepartment = this.userDepartmentId;
        }
        if (this.selectedDepartment && !this.isTeacherRole) {
          empParams._department = this.selectedDepartment;
        }

        const assignParams = {};
        if (this.selectedDepartment && !this.isTeacherRole) {
          assignParams.departmentId = this.selectedDepartment;
        } else if (this.isDekanRole && this.userDepartmentId && this.userDepartmentId !== 31) {
          assignParams.facultyId = this.userDepartmentId;
        } else if (this.isTeacherRole && this.loggedInUser) {
          if (this.loggedInUser.name) assignParams.teacherName = this.loggedInUser.name;
          const eId = this.loggedInUser.employee_id_number || (String(this.loggedInUser.employee_id || '').length >= 7 ? this.loggedInUser.employee_id : null) || this.loggedInUser.hemis_id;
          if (eId) assignParams.employeeId = eId;
        }

        // Parallel fetch for employees and shaxsiy-reja assignments
        const [empRes, assignRes] = await Promise.all([
          axios.get(`${API}/employees`, {
            headers: { Authorization: `Bearer ${token}` },
            params: empParams
          }),
          axios.get(`${API}/shaxsiy-reja`, {
            headers: { Authorization: `Bearer ${token}` },
            params: assignParams
          })
        ]);

        if (empRes.data.success) {
          let items = empRes.data.data?.items || empRes.data.data || [];
          // Faqat amalda ishlayotganlarni ('Ishlamoqda') qoldirish, bo'shaganlarni qat'iy chiqarib tashlash
          items = items.filter(emp => {
            const statusCode = String(emp.employeeStatus?.code || '').trim();
            const statusName = (emp.employeeStatus?.name || '').toLowerCase().trim();
            if (statusCode === '14' || statusName.includes('bo‘sha') || statusName.includes('bo\'sha') || statusName.includes('boshagan') || statusName.includes('dismissed')) {
              return false;
            }
            if (statusCode === '11' || statusName.includes('ishla') || statusName.includes('faol') || statusName.includes('active')) {
              return true;
            }
            return false;
          });
          this.employees = items;
        }

        if (assignRes.data.success) {
          this.assignments = assignRes.data.data || [];
          const map = {};
          for (const item of this.assignments) {
            map[String(item.employeeId)] = item;
          }
          this.assignmentMap = map;
        }
      } catch (err) {
        console.error("Xodimlarni yuklashda xato:", err);
      } finally {
        this.loading = false;
      }
    },
    async syncEmployeesDatabase() {
      this.syncing = true;
      try {
        const token = localStorage.getItem("token");
        const res = await axios.post(`${API}/employees/sync`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          alert(res.data.message || "Xodimlar muvaffaqiyatli yangilandi");
          await this.fetchEmployees();
        } else {
          alert(res.data.error || "Xatolik yuz berdi");
        }
      } catch (err) {
        console.error("Sync error:", err);
        alert(err.response?.data?.error || err.message || "Xodimlarni yangilashda xatolik yuz berdi");
      } finally {
        this.syncing = false;
      }
    },
    async fetchAssignments() {
      try {
        const token = localStorage.getItem("token");
        const params = {};
        if (this.selectedDepartment) {
          params.departmentId = this.selectedDepartment;
        }
        const res = await axios.get(`${API}/shaxsiy-reja`, {
          headers: { Authorization: `Bearer ${token}` },
          params
        });
        if (res.data.success) {
          this.assignments = res.data.data || [];
          const map = {};
          for (const item of this.assignments) {
            map[String(item.employeeId)] = item;
          }
          this.assignmentMap = map;
        }
      } catch (err) {
        console.error("Error fetching assignments", err);
      }
    },
    clearFilters() {
      this.activeStatusFilter = "";
      this.currentViewTab = this.isProrektorRole ? "waiting" : "all";
      sessionStorage.setItem("shaxsiy_reja_current_tab", this.currentViewTab);
      if (this.isKafedraMudirRole) {
        this.selectedDepartment = this.userDepartmentId;
      } else {
        this.selectedDepartment = "";
      }
      sessionStorage.removeItem("shaxsiy_reja_selected_department");
      if (this.$route.query.departmentId || this.$route.query._department) {
        this.$router.replace({ path: '/shaxsiy-ish-reja' }).catch(() => {});
      }
      this.selectedStavka = "";
      this.searchQuery = "";
      this.fetchEmployees();
    },
    switchViewTab(tabKey) {
      this.currentViewTab = tabKey;
      this.activeStatusFilter = "";
      sessionStorage.setItem("shaxsiy_reja_current_tab", tabKey);
    },
    clearActiveFilter() {
      this.activeStatusFilter = "";
    },
    toggleStatusFilter(filterKey) {
      if (this.activeStatusFilter === filterKey) {
        this.activeStatusFilter = "";
      } else {
        this.activeStatusFilter = filterKey;
      }
    },
    getActiveFilterName() {
      switch (this.activeStatusFilter) {
        case 'teacher_approved': return "O'qituvchi tasdiqlagan";
        case 'kafedra_approved': return "Kafedra mudiri tasdiqlagan";
        case 'dekan_approved': return "Dekan tasdiqlagan";
        case 'prorektor_approved': return "Prorektor tasdiqlagan";
        case 'waiting': return "Kutilmoqda";
        case 'rejected': return "Rad etilgan";
        default: return "";
      }
    },
    goToDetail(item) {
      const currentDeptId = this.selectedDepartment || item.departmentId || "";
      if (currentDeptId) {
        sessionStorage.setItem("shaxsiy_reja_selected_department", String(currentDeptId));
      }
      sessionStorage.setItem("shaxsiy_reja_current_tab", this.currentViewTab || "waiting");

      const itemStavkaLower = (item.stavka || '').toLowerCase();
      const fracMatch = itemStavkaLower.match(/0[.,]\d+/);
      const fracStr = fracMatch ? fracMatch[0].replace(',', '.') : null;
      const emp = (this.employees || []).find(e => {
        const idMatch = String(e.employee_id_number || e.id || e.meta_id) === String(item.employeeId) || String(e.meta_id) === String(item.employeeId);
        const nameMatch = (e.full_name && item.employeeName && e.full_name.trim().toLowerCase() === item.employeeName.trim().toLowerCase());
        const eStavka = (e.employmentStaff?.name || '').toLowerCase().replace(',', '.');
        if (fracStr) {
          if (idMatch && (eStavka.includes(fracStr) || String(e.meta_id) === String(item.employeeId))) return true;
          if (nameMatch && eStavka.includes(fracStr)) return true;
        }
        return idMatch || nameMatch;
      }) || {};

      // Use the plan's exact employeeId from the row
      let finalEmpId = item.employeeId ? String(item.employeeId) : "";
      if (!finalEmpId) {
        finalEmpId = emp.employee_id_number ? String(emp.employee_id_number) : String(emp.meta_id || "");
      }
      
      let spec = item.teacherMeta?.specialty || "";
      if (!spec) {
        if (typeof emp.specialty === 'object' && emp.specialty) {
          spec = emp.specialty.name || "";
        } else if (typeof emp.specialty === 'string') {
          spec = emp.specialty;
        }
      }
      if (!spec || /^\d{2}\.\d{2}/.test(spec.trim())) {
        spec = item.kafedraName || emp.department?.name || "";
      }

      const degree = (item.degree && item.degree !== "Darajasiz")
        ? item.degree
        : (item.teacherMeta?.academicDegree && item.teacherMeta.academicDegree !== "Darajasiz"
            ? item.teacherMeta.academicDegree
            : (emp.academicDegree?.name || "Darajasiz"));

      const rank = (item.rank && item.rank !== "Unvonsiz")
        ? item.rank
        : (item.teacherMeta?.academicRank && item.teacherMeta.academicRank !== "Unvonsiz"
            ? item.teacherMeta.academicRank
            : (emp.academicRank?.name || "Unvonsiz"));

      let stavka = item.stavka || item.teacherMeta?.stavka || emp.employmentStaff?.name || "1,00 stavka";
      const isShortId = String(item.employeeId).length < 7;
      if (isShortId && (stavka.includes("1,00") || stavka.includes("1.00"))) {
        stavka = emp.employmentStaff?.name || "0,50 stavka";
      }
      const position = item.position || item.teacherMeta?.position || emp.staffPosition?.name || "O'qituvchi";
      const faculty = item.teacherMeta?.faculty || (emp.department ? (emp.department.facultyName || "") : "") || "";

      const isOct = this.$route.path.startsWith('/oktyabr');
      this.$router.push({
        name: isOct ? "okt-shaxsiy-ish-reja-detail" : "shaxsiy-ish-reja-detail",
        params: { employeeId: finalEmpId },
        query: {
          name: item.employeeName || emp.full_name || emp.name || "",
          kafedra: item.kafedraName || emp.department?.name || "",
          departmentId: currentDeptId,
          tab: this.currentViewTab || "waiting",
          stavka,
          degree,
          rank,
          position,
          specialty: spec || "",
          faculty
        }
      });
    },
    getStatusText(item) {
      if (!item.status) return "O'qituvchi kutilmoqda";
      if (Object.values(item.status).some(v => v === "rejected")) {
        return "Rad etilgan";
      }
      if (this.isProrektorRole) {
        if (this.isApprovedByMe(item)) {
          return "Prorektor tasdiqlagan";
        }
        if (this.isWaitingForMe(item)) {
          return "Tasdiq kutilmoqda";
        }
      }
      if (item.status.oquv === "approved" || item.status.ilmiy === "approved" || item.status.yoshlar === "approved") {
        return "Prorektor tasdiqlagan";
      }
      if (item.status.dekan === "approved") {
        return "Dekan tasdiqlagan";
      }
      if (item.status.kafedra === "approved") {
        return "Kafedra tasdiqlagan";
      }
      if (item.status.teacher === "approved") {
        return "O'qituvchi tasdiqlagan";
      }
      return "O'qituvchi kutilmoqda";
    },
    getStatusClass(item) {
      if (!item.status) return "badge-waiting";
      if (Object.values(item.status).some(v => v === "rejected")) {
        return "badge-rejected";
      }
      if (this.isProrektorRole) {
        if (this.isApprovedByMe(item)) {
          return "badge-approved";
        }
        if (this.isWaitingForMe(item)) {
          return "badge-waiting badge-pulse";
        }
      }
      if (item.status.oquv === "approved" || item.status.ilmiy === "approved" || item.status.yoshlar === "approved") {
        return "badge-approved";
      }
      if (item.status.dekan === "approved") {
        return "badge-dekan";
      }
      if (item.status.kafedra === "approved") {
        return "badge-kafedra";
      }
      if (item.status.teacher === "approved") {
        return "badge-teacher";
      }
      return "badge-waiting";
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  background-color: #f8fafc;
  min-height: calc(100vh - 64px);
}

.page-container {
  max-width: 100%;
  margin: 0 auto;
}

.page-header {
  background: white;
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  margin: -16px -16px 16px -16px;
}

@media (min-width: 1024px) {
  .page-header {
    margin: -24px -24px 24px -24px;
  }
}

.breadcrumb {
  font-size: 14px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.crumb-link {
  cursor: pointer;
  color: #3b82f6;
  transition: color 0.2s;
}

.crumb-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

.separator {
  color: #cbd5e1;
}

.crumb-current {
  color: #475569;
  font-weight: 500;
}

/* Summary Cards */
.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.summary-card {
  border-radius: 8px;
  padding: 16px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;
  user-select: none;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
}

.summary-card.card-active {
  box-shadow: 0 0 0 3px #1e293b, 0 8px 16px rgba(0, 0, 0, 0.2);
  transform: scale(1.02);
}

.card-content {
  display: flex;
  flex-direction: column;
}

.card-value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  margin: 0 0 6px 0;
}

.card-label {
  font-size: 13px;
  font-weight: 500;
  margin: 0;
  opacity: 0.95;
  white-space: nowrap;
}

.card-icon {
  opacity: 0.85;
}

/* Card color gradients matching modern UI */
.card-blue {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.card-purple {
  background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
}

.card-teal {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
}

.card-green {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.card-yellow {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.card-red {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

/* Active filter banner */
.active-filter-banner {
  background-color: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 8px 14px;
}

.filter-pill {
  background-color: #3b82f6;
  color: white;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.btn-clear-filter {
  color: #dc2626;
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
}

.btn-clear-filter:hover {
  text-decoration: underline;
}

/* Filters Row */
.filters-row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.filter-select {
  height: 40px;
  min-width: 200px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  color: #475569;
  outline: none;
  background-color: #fff;
}

.filter-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.search-box {
  position: relative;
  display: flex;
  min-width: 260px;
}

.search-input {
  width: 100%;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 6px 0 0 6px;
  padding: 0 16px;
  font-size: 14px;
  outline: none;
}

.search-input:focus {
  border-color: #3b82f6;
  z-index: 1;
}

.search-btn {
  height: 40px;
  width: 44px;
  background-color: #334155;
  color: white;
  border: none;
  border-radius: 0 6px 6px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.search-btn:hover {
  background-color: #1e293b;
}

.btn-clear {
  height: 40px;
  padding: 0 16px;
  border: 1px solid #ef4444;
  color: #ef4444;
  background: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-clear:hover {
  background: #fef2f2;
}

.btn-filter {
  height: 40px;
  padding: 0 20px;
  background-color: #334155;
  color: white;
  border: none;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
}

.btn-filter:hover {
  background-color: #1e293b;
}

/* Table Card */
.table-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 20px;
}

.main-table {
  width: 100%;
  border-collapse: collapse;
}

.main-table th {
  padding: 12px 16px;
  font-weight: 600;
  font-size: 13px;
  color: #475569;
  border-bottom: 2px solid #e2e8f0;
}

.main-table td {
  padding: 14px 16px;
  font-size: 14px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.main-table tr:hover td {
  background-color: #f8fafc;
}

.emp-name {
  color: #2563eb;
  font-weight: 500;
}

.font-bold {
  font-weight: 700;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.badge-waiting {
  background-color: #d97706;
  color: white;
}

.badge-approved {
  background-color: #16a34a;
  color: white;
}

.badge-dekan {
  background-color: #0891b2;
  color: white;
}

.badge-kafedra {
  background-color: #7c3aed;
  color: white;
}

.badge-teacher {
  background-color: #2563eb;
  color: white;
}

.badge-rejected {
  background-color: #dc2626;
  color: white;
}

.pagination-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-number {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  background-color: #8b5cf6;
  color: white;
  font-size: 14px;
}

.clickable-link {
  color: #2563eb;
  cursor: pointer;
  font-weight: 500;
}
.clickable-link:hover {
  text-decoration: underline;
  color: #1d4ed8;
}

/* Table Totals (Jami) Footer */
.table-totals-footer {
  background-color: #f8fafc;
  border-top: 2px solid #cbd5e1;
}

.totals-row td {
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 700;
  border-top: 2px solid #cbd5e1;
  border-bottom: 2px solid #cbd5e1;
}

.totals-title-cell {
  color: #1e293b;
  font-size: 15px;
  letter-spacing: 0.5px;
}

.totals-val-cell {
  font-variant-numeric: tabular-nums;
  font-size: 15px;
}

.totals-row .text-blue-700 {
  color: #1d4ed8;
  background-color: #eff6ff;
}

.totals-row .text-indigo-700 {
  color: #4338ca;
  background-color: #eef2ff;
}

.totals-row .text-emerald-700 {
  color: #047857;
  background-color: #ecfdf5;
}

.btn-sync-emp {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(2, 132, 199, 0.2);
  transition: all 0.2s ease;
}

.btn-sync-emp:hover:not(:disabled) {
  background: linear-gradient(135deg, #0369a1 0%, #075985 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(2, 132, 199, 0.3);
}

.btn-sync-emp:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.spinner-small {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.totals-grand-val {
  font-size: 16px !important;
  font-weight: 800 !important;
}

/* ========================================================
   PROREKTOR / TASDIQLASH TABS & TEZKOR AMALLAR STILI
   ======================================================== */

.active-filter-banner {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  padding: 8px 16px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.filter-pill {
  background: #3b82f6;
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.btn-clear-filter {
  background: white;
  border: 1px solid #cbd5e1;
  color: #64748b;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-clear-filter:hover {
  background: #fee2e2;
  color: #dc2626;
  border-color: #fca5a5;
}

.prorektor-tabs-bar {
  background: #ffffff;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.prorektor-tabs-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.p-tab-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 18px;
  border-radius: 9px;
  font-size: 13.5px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
  transition: all 0.22s ease-in-out;
  user-select: none;
}

.p-tab-btn:hover {
  background: #f1f5f9;
  color: #1e293b;
  transform: translateY(-1px);
}

.p-tab-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.p-tab-counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

/* Counters default colors */
.counter-amber {
  background: #fef3c7;
  color: #b45309;
}

.counter-green {
  background: #dcfce7;
  color: #15803d;
}

.counter-red {
  background: #fee2e2;
  color: #b91c1c;
}

.counter-slate {
  background: #e2e8f0;
  color: #475569;
}

/* Tab Active States */
.tab-btn-waiting.active {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
  color: #ffffff;
  border-color: #b45309;
  box-shadow: 0 4px 10px rgba(217, 119, 6, 0.35);
}
.tab-btn-waiting.active .p-tab-counter {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.tab-btn-approved.active {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  color: #ffffff;
  border-color: #047857;
  box-shadow: 0 4px 10px rgba(5, 150, 105, 0.35);
}
.tab-btn-approved.active .p-tab-counter {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.tab-btn-rejected.active {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: #ffffff;
  border-color: #b91c1c;
  box-shadow: 0 4px 10px rgba(220, 38, 38, 0.35);
}
.tab-btn-rejected.active .p-tab-counter {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.tab-btn-all.active {
  background: linear-gradient(135deg, #475569 0%, #1e293b 100%);
  color: #ffffff;
  border-color: #1e293b;
  box-shadow: 0 4px 10px rgba(30, 41, 59, 0.35);
}
.tab-btn-all.active .p-tab-counter {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

/* Action Buttons in Table */
.btn-row-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s ease;
  white-space: nowrap;
}

.btn-action-approve {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border: 1px solid #b45309;
  box-shadow: 0 2px 4px rgba(217, 119, 6, 0.25);
}

.btn-action-approve:hover {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(217, 119, 6, 0.4);
}

.btn-action-view {
  background: #f8fafc;
  color: #3b82f6;
  border: 1px solid #bfdbfe;
}

.btn-action-view:hover {
  background: #eff6ff;
  color: #1d4ed8;
  border-color: #93c5fd;
  transform: translateY(-1px);
}

/* Badge pulse animation for pending approval */
.badge-pulse {
  position: relative;
  box-shadow: 0 0 0 0 rgba(217, 119, 6, 0.7);
  animation: pulse-orange 1.8s infinite;
}

@keyframes pulse-orange {
  0% {
    transform: scale(0.98);
    box-shadow: 0 0 0 0 rgba(217, 119, 6, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(217, 119, 6, 0);
  }
  100% {
    transform: scale(0.98);
    box-shadow: 0 0 0 0 rgba(217, 119, 6, 0);
  }
}
</style>
